export const AMAZON_PAY_JS = 'https://static-na.payments-amazon.com/checkout.js';
export const AFTER_PAY_BUTTON_JS = 'https://www.zappos.com/marty-assets/afterpay-button.js';
export const AFTER_PAY_JS = 'https://www.zappos.com/marty-assets/afterpay-1.x.js';
export const PAYPAL_JS = 'https://www.paypal.com/sdk/js';

export const AMAZON_PAY_JS_TYPE = 'AMAZON_PAY_JS_TYPE';
export const AFTER_PAY_JS_TYPE = 'AFTER_PAY_JS_TYPE';
export const AFTER_PAY_BUTTON_JS_TYPE = 'AFTER_PAY_BUTTON_JS_TYPE';
export const PAYPAL_JS_TYPE = 'PAYPAL_JS_TYPE';
